<template>
  <div class="list" @click="detailsTap(item.id)">
    <div class="list-title">{{ item.goodsName }}</div>
    <div class="list-main">
      <div class="list-main-imgwrap">
        <van-image
          class="list-main-imgwrap-img"
          fit="cover"
          :src="item.oraimg"
        />
        <div class="list-main-imgwrap-tab" v-if="item.useCoupon == 1">券</div>
      </div>
      <div class="list-main-info">
        <div class="list-main-info-price">
          {{ item.priceType == 1 ? '' : '￥'
          }}<span>{{ item.priceType == 1 ? '面议' : item.price }}</span>
        </div>
        <div class="list-main-info-count" v-if="num">
          机构名称：{{ item.entName }}
        </div>
        <div class="list-main-info-count" v-else>
          交易量：{{ item.orderCount }}
        </div>
        <div class="list-main-info-type">类型：{{ item.goodsTypeName }}</div>
        <div
          class="list-main-info-mechanism"
          @click.stop="details(item.creditCode)"
        >
          <div>{{ item.entName }}</div>
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  props: ['item', 'num'],
  methods: {
    detailsTap(id) {
      this.buriedPoint()
      this.$router.push({
        path: '/market/listDetails',
        query: {
          id: id
        }
      })
    },
    details(creditCode) {
      this.$router.push({ name: 'organ', query: { id: creditCode } })
    },
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  background: #fff;
  border-radius: 4px;
  width: 100%;
  margin-top: 10px;
  &-title {
    font-size: 16px;
    padding: 10px 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #eee;
  }
  &-main {
    padding: 10px 15px;
    display: flex;
    &-imgwrap {
      position: relative;
      &-img {
        width: 90px;
        height: 80px;
      }
      &-tab {
        padding: 6px;
        background: #ff5c2c;
        font-size: 12px;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        border-bottom-right-radius: 10px;
      }
    }
    &-info {
      flex: 1;
      padding-left: 10px;
      overflow: hidden;
      &-price {
        font-size: 14px;
        color: #999;
        span {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
      }
      &-count,
      &-type {
        font-size: 14px;
        color: #999;
        margin-top: 7px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-mechanism {
        min-width: 105px;
        max-width: 72%;
        height: 24px;
        display: flex;
        margin-top: 5px;
        padding: 0 5px;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        background: #e8f4ff;
        border-radius: 8px;
        color: #0080ff;
        > div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
